/** Parse API text fields (forecast / actual / previous) into comparable numbers where possible */

const SENTINELS = new Set([
  "",
  "-",
  "--",
  "—",
  "–",
  "n/a",
  "na",
  "tbd",
  "...",
]);

function normalizeAscii(s: string): string {
  return s.trim().replace(/[–—−]/g, "-");
}

export function parseEconomicValue(raw: string | undefined | null): number | null {
  if (raw == null) return null;
  let s = normalizeAscii(String(raw));
  if (!s.length) return null;
  const low = s.toLowerCase().replace(/\s+/g, "");
  if (SENTINELS.has(low)) return null;
  /** Strip wrapping parens/brackets artifacts */
  s = s.replace(/^\(+|\)+$/g, "").trim();

  let isPercent = false;
  if (/%\s*$/.test(s)) {
    isPercent = true;
    s = s.replace(/%\s*$/, "").trim();
  }

  let mult = 1;
  const km = /\s*([km])\s*$/i.exec(s);
  if (km) {
    mult = km[1].toLowerCase() === "k" ? 1e3 : 1e6;
    s = s.slice(0, km.index).trim();
  }

  /** Remove commas used as thousand separators */
  s = s.replace(/,/g, "");

  /** Optional leading +/- */
  let sign = 1;
  if (s.startsWith("+")) {
    s = s.slice(1).trim();
  } else if (s.startsWith("-")) {
    sign = -1;
    s = s.slice(1).trim();
  }

  /** Allow decimal with dot */
  const m = /^[\d]*\.?\d+(?:e[+-]?\d+)?$/i.exec(s);
  if (!m) return null;
  const v = Number.parseFloat(s);
  if (!Number.isFinite(v)) return null;
  const out = sign * v * mult;
  /** Preserve percent display magnitude as number (plan: 13% → 13) */
  void isPercent;
  return out;
}
